// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               unknown
// source: Protos/V1/Models/InferenceModels.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import Long from "long";
import { Timestamp } from "../../../google/protobuf/timestamp";

export const protobufPackage = "daisi.protos.v1";

export enum InferenceCloseReasons {
  CloseTimeout = 0,
  CloseHostClosing = 1,
  CloseError = 2,
  CloseRequestedByClient = 3,
  UNRECOGNIZED = -1,
}

export function inferenceCloseReasonsFromJSON(object: any): InferenceCloseReasons {
  switch (object) {
    case 0:
    case "CloseTimeout":
      return InferenceCloseReasons.CloseTimeout;
    case 1:
    case "CloseHostClosing":
      return InferenceCloseReasons.CloseHostClosing;
    case 2:
    case "CloseError":
      return InferenceCloseReasons.CloseError;
    case 3:
    case "CloseRequestedByClient":
      return InferenceCloseReasons.CloseRequestedByClient;
    case -1:
    case "UNRECOGNIZED":
    default:
      return InferenceCloseReasons.UNRECOGNIZED;
  }
}

export function inferenceCloseReasonsToJSON(object: InferenceCloseReasons): string {
  switch (object) {
    case InferenceCloseReasons.CloseTimeout:
      return "CloseTimeout";
    case InferenceCloseReasons.CloseHostClosing:
      return "CloseHostClosing";
    case InferenceCloseReasons.CloseError:
      return "CloseError";
    case InferenceCloseReasons.CloseRequestedByClient:
      return "CloseRequestedByClient";
    case InferenceCloseReasons.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum ThinkLevels {
  ThinkLevelsBasic = 0,
  ThinkLevelsBasicWithTools = 1,
  ThinkLevelsSkilled = 2,
  UNRECOGNIZED = -1,
}

export function thinkLevelsFromJSON(object: any): ThinkLevels {
  switch (object) {
    case 0:
    case "ThinkLevelsBasic":
      return ThinkLevels.ThinkLevelsBasic;
    case 1:
    case "ThinkLevelsBasicWithTools":
      return ThinkLevels.ThinkLevelsBasicWithTools;
    case 2:
    case "ThinkLevelsSkilled":
      return ThinkLevels.ThinkLevelsSkilled;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ThinkLevels.UNRECOGNIZED;
  }
}

export function thinkLevelsToJSON(object: ThinkLevels): string {
  switch (object) {
    case ThinkLevels.ThinkLevelsBasic:
      return "ThinkLevelsBasic";
    case ThinkLevels.ThinkLevelsBasicWithTools:
      return "ThinkLevelsBasicWithTools";
    case ThinkLevels.ThinkLevelsSkilled:
      return "ThinkLevelsSkilled";
    case ThinkLevels.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum InferenceResponseTypes {
  InferenceResponseTypesError = 0,
  InferenceResponseTypesThinking = 1,
  InferenceResponseTypesTooling = 2,
  InferenceResponseTypesToolContent = 3,
  InferenceResponseTypesText = 4,
  InferenceResponseTypesImage = 5,
  InferenceResponseTypesAudio = 6,
  UNRECOGNIZED = -1,
}

export function inferenceResponseTypesFromJSON(object: any): InferenceResponseTypes {
  switch (object) {
    case 0:
    case "InferenceResponseTypesError":
      return InferenceResponseTypes.InferenceResponseTypesError;
    case 1:
    case "InferenceResponseTypesThinking":
      return InferenceResponseTypes.InferenceResponseTypesThinking;
    case 2:
    case "InferenceResponseTypesTooling":
      return InferenceResponseTypes.InferenceResponseTypesTooling;
    case 3:
    case "InferenceResponseTypesToolContent":
      return InferenceResponseTypes.InferenceResponseTypesToolContent;
    case 4:
    case "InferenceResponseTypesText":
      return InferenceResponseTypes.InferenceResponseTypesText;
    case 5:
    case "InferenceResponseTypesImage":
      return InferenceResponseTypes.InferenceResponseTypesImage;
    case 6:
    case "InferenceResponseTypesAudio":
      return InferenceResponseTypes.InferenceResponseTypesAudio;
    case -1:
    case "UNRECOGNIZED":
    default:
      return InferenceResponseTypes.UNRECOGNIZED;
  }
}

export function inferenceResponseTypesToJSON(object: InferenceResponseTypes): string {
  switch (object) {
    case InferenceResponseTypes.InferenceResponseTypesError:
      return "InferenceResponseTypesError";
    case InferenceResponseTypes.InferenceResponseTypesThinking:
      return "InferenceResponseTypesThinking";
    case InferenceResponseTypes.InferenceResponseTypesTooling:
      return "InferenceResponseTypesTooling";
    case InferenceResponseTypes.InferenceResponseTypesToolContent:
      return "InferenceResponseTypesToolContent";
    case InferenceResponseTypes.InferenceResponseTypesText:
      return "InferenceResponseTypesText";
    case InferenceResponseTypes.InferenceResponseTypesImage:
      return "InferenceResponseTypesImage";
    case InferenceResponseTypes.InferenceResponseTypesAudio:
      return "InferenceResponseTypesAudio";
    case InferenceResponseTypes.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum InferenceOutputFormats {
  InferenceOutputFormatsPlainText = 0,
  InferenceOutputFormatsJson = 1,
  InferenceOutputFormatsMarkdown = 2,
  InferenceOutputFormatsBase64 = 3,
  InferenceOutputFormatsHtml = 4,
  UNRECOGNIZED = -1,
}

export function inferenceOutputFormatsFromJSON(object: any): InferenceOutputFormats {
  switch (object) {
    case 0:
    case "InferenceOutputFormatsPlainText":
      return InferenceOutputFormats.InferenceOutputFormatsPlainText;
    case 1:
    case "InferenceOutputFormatsJson":
      return InferenceOutputFormats.InferenceOutputFormatsJson;
    case 2:
    case "InferenceOutputFormatsMarkdown":
      return InferenceOutputFormats.InferenceOutputFormatsMarkdown;
    case 3:
    case "InferenceOutputFormatsBase64":
      return InferenceOutputFormats.InferenceOutputFormatsBase64;
    case 4:
    case "InferenceOutputFormatsHtml":
      return InferenceOutputFormats.InferenceOutputFormatsHtml;
    case -1:
    case "UNRECOGNIZED":
    default:
      return InferenceOutputFormats.UNRECOGNIZED;
  }
}

export function inferenceOutputFormatsToJSON(object: InferenceOutputFormats): string {
  switch (object) {
    case InferenceOutputFormats.InferenceOutputFormatsPlainText:
      return "InferenceOutputFormatsPlainText";
    case InferenceOutputFormats.InferenceOutputFormatsJson:
      return "InferenceOutputFormatsJson";
    case InferenceOutputFormats.InferenceOutputFormatsMarkdown:
      return "InferenceOutputFormatsMarkdown";
    case InferenceOutputFormats.InferenceOutputFormatsBase64:
      return "InferenceOutputFormatsBase64";
    case InferenceOutputFormats.InferenceOutputFormatsHtml:
      return "InferenceOutputFormatsHtml";
    case InferenceOutputFormats.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum InferenceToolGroups {
  InferenceToolGroupsInformationTools = 0,
  InferenceToolGroupsFileTools = 1,
  InferenceToolGroupsMathTools = 2,
  InferenceToolGroupsCommunicationTools = 3,
  InferenceToolGroupsCodingTools = 4,
  InferenceToolGroupsMediaTools = 5,
  InferenceToolGroupsIntegrationTools = 6,
  InferenceToolGroupsSocialTools = 7,
  InferenceToolGroupsShellTools = 8,
  InferenceToolGroupsScreenTools = 9,
  InferenceToolGroupsInputTools = 10,
  InferenceToolGroupsClipboardTools = 11,
  InferenceToolGroupsBrowserTools = 12,
  InferenceToolGroupsWindowTools = 13,
  InferenceToolGroupsSystemTools = 14,
  InferenceToolGroupsGitTools = 15,
  UNRECOGNIZED = -1,
}

export function inferenceToolGroupsFromJSON(object: any): InferenceToolGroups {
  switch (object) {
    case 0:
    case "InferenceToolGroupsInformationTools":
      return InferenceToolGroups.InferenceToolGroupsInformationTools;
    case 1:
    case "InferenceToolGroupsFileTools":
      return InferenceToolGroups.InferenceToolGroupsFileTools;
    case 2:
    case "InferenceToolGroupsMathTools":
      return InferenceToolGroups.InferenceToolGroupsMathTools;
    case 3:
    case "InferenceToolGroupsCommunicationTools":
      return InferenceToolGroups.InferenceToolGroupsCommunicationTools;
    case 4:
    case "InferenceToolGroupsCodingTools":
      return InferenceToolGroups.InferenceToolGroupsCodingTools;
    case 5:
    case "InferenceToolGroupsMediaTools":
      return InferenceToolGroups.InferenceToolGroupsMediaTools;
    case 6:
    case "InferenceToolGroupsIntegrationTools":
      return InferenceToolGroups.InferenceToolGroupsIntegrationTools;
    case 7:
    case "InferenceToolGroupsSocialTools":
      return InferenceToolGroups.InferenceToolGroupsSocialTools;
    case 8:
    case "InferenceToolGroupsShellTools":
      return InferenceToolGroups.InferenceToolGroupsShellTools;
    case 9:
    case "InferenceToolGroupsScreenTools":
      return InferenceToolGroups.InferenceToolGroupsScreenTools;
    case 10:
    case "InferenceToolGroupsInputTools":
      return InferenceToolGroups.InferenceToolGroupsInputTools;
    case 11:
    case "InferenceToolGroupsClipboardTools":
      return InferenceToolGroups.InferenceToolGroupsClipboardTools;
    case 12:
    case "InferenceToolGroupsBrowserTools":
      return InferenceToolGroups.InferenceToolGroupsBrowserTools;
    case 13:
    case "InferenceToolGroupsWindowTools":
      return InferenceToolGroups.InferenceToolGroupsWindowTools;
    case 14:
    case "InferenceToolGroupsSystemTools":
      return InferenceToolGroups.InferenceToolGroupsSystemTools;
    case 15:
    case "InferenceToolGroupsGitTools":
      return InferenceToolGroups.InferenceToolGroupsGitTools;
    case -1:
    case "UNRECOGNIZED":
    default:
      return InferenceToolGroups.UNRECOGNIZED;
  }
}

export function inferenceToolGroupsToJSON(object: InferenceToolGroups): string {
  switch (object) {
    case InferenceToolGroups.InferenceToolGroupsInformationTools:
      return "InferenceToolGroupsInformationTools";
    case InferenceToolGroups.InferenceToolGroupsFileTools:
      return "InferenceToolGroupsFileTools";
    case InferenceToolGroups.InferenceToolGroupsMathTools:
      return "InferenceToolGroupsMathTools";
    case InferenceToolGroups.InferenceToolGroupsCommunicationTools:
      return "InferenceToolGroupsCommunicationTools";
    case InferenceToolGroups.InferenceToolGroupsCodingTools:
      return "InferenceToolGroupsCodingTools";
    case InferenceToolGroups.InferenceToolGroupsMediaTools:
      return "InferenceToolGroupsMediaTools";
    case InferenceToolGroups.InferenceToolGroupsIntegrationTools:
      return "InferenceToolGroupsIntegrationTools";
    case InferenceToolGroups.InferenceToolGroupsSocialTools:
      return "InferenceToolGroupsSocialTools";
    case InferenceToolGroups.InferenceToolGroupsShellTools:
      return "InferenceToolGroupsShellTools";
    case InferenceToolGroups.InferenceToolGroupsScreenTools:
      return "InferenceToolGroupsScreenTools";
    case InferenceToolGroups.InferenceToolGroupsInputTools:
      return "InferenceToolGroupsInputTools";
    case InferenceToolGroups.InferenceToolGroupsClipboardTools:
      return "InferenceToolGroupsClipboardTools";
    case InferenceToolGroups.InferenceToolGroupsBrowserTools:
      return "InferenceToolGroupsBrowserTools";
    case InferenceToolGroups.InferenceToolGroupsWindowTools:
      return "InferenceToolGroupsWindowTools";
    case InferenceToolGroups.InferenceToolGroupsSystemTools:
      return "InferenceToolGroupsSystemTools";
    case InferenceToolGroups.InferenceToolGroupsGitTools:
      return "InferenceToolGroupsGitTools";
    case InferenceToolGroups.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface SendInferenceRequest {
  SessionId: string;
  InferenceId: string;
  Text: string;
  ToolGroup?: InferenceToolGroups | undefined;
  ToolName?: string | undefined;
  AntiPrompts: string[];
  TokensKeep?: number | undefined;
  MaxTokens?: number | undefined;
  DecodeSpecialTokens?: boolean | undefined;
  Temperature?: number | undefined;
  TopP?: number | undefined;
  TopK?: number | undefined;
  RepeatPenalty?: number | undefined;
  Seed?: number | undefined;
  FrequencyPenalty?: number | undefined;
  PresencePenalty?: number | undefined;
  MinKeep?: number | undefined;
  MinP?: number | undefined;
  PenalizeNewline?: boolean | undefined;
  PenaltyCount?: number | undefined;
  PreventEOS?: boolean | undefined;
  TypicalP?: number | undefined;
  ThinkLevel?: ThinkLevels | undefined;
  OutputFormat?: InferenceOutputFormats | undefined;
  ExampleOutput?: string | undefined;
}

export interface SendInferenceResponse {
  SessionId: string;
  InferenceId: string;
  Id: string;
  Type: InferenceResponseTypes;
  Content: string;
  AuthorRole: string;
  Format: InferenceOutputFormats;
  MessageTokenCount: number;
  SessionTokenCount: number;
  ComputeTimeMs: number;
}

export interface InferenceStatsRequest {
  SessionId: string;
  InferenceId: string;
}

export interface InferenceStatsResponse {
  SessionId: string;
  InferenceId: string;
  Success: boolean;
  LastMessageTokenCount: number;
  SessionTokenCount: number;
  LastMessageToolCount: number;
  SessionToolCount: number;
  LastMessageComputeTimeMs: number;
  SessionComputeTimeMs: number;
}

export interface CreateInferenceRequest {
  SessionId: string;
  ModelName: string;
  InitializationPrompt: string;
  ThinkLevel: ThinkLevels;
  ToolGroups: InferenceToolGroups[];
}

export interface CreateInferenceResponse {
  SessionId: string;
  InferenceId: string;
}

export interface CloseInferenceRequest {
  SessionId: string;
  InferenceId: string;
  Reason: InferenceCloseReasons;
}

export interface CloseInferenceResponse {
  SessionId: string;
  InferenceId: string;
  Success: boolean;
}

export interface InferenceReceipt {
  InferenceId: string;
  SessionId: string;
  HostId: string;
  ConsumerAccountId: string;
  TokenCount: number;
  ComputeTimeMs: number;
  ModelName: string;
  Timestamp?: Date | undefined;
  ConsumerClientKey: string;
}

function createBaseSendInferenceRequest(): SendInferenceRequest {
  return {
    SessionId: "",
    InferenceId: "",
    Text: "",
    ToolGroup: undefined,
    ToolName: undefined,
    AntiPrompts: [],
    TokensKeep: undefined,
    MaxTokens: undefined,
    DecodeSpecialTokens: undefined,
    Temperature: undefined,
    TopP: undefined,
    TopK: undefined,
    RepeatPenalty: undefined,
    Seed: undefined,
    FrequencyPenalty: undefined,
    PresencePenalty: undefined,
    MinKeep: undefined,
    MinP: undefined,
    PenalizeNewline: undefined,
    PenaltyCount: undefined,
    PreventEOS: undefined,
    TypicalP: undefined,
    ThinkLevel: undefined,
    OutputFormat: undefined,
    ExampleOutput: undefined,
  };
}

export const SendInferenceRequest: MessageFns<SendInferenceRequest> = {
  encode(message: SendInferenceRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.SessionId !== "") {
      writer.uint32(10).string(message.SessionId);
    }
    if (message.InferenceId !== "") {
      writer.uint32(18).string(message.InferenceId);
    }
    if (message.Text !== "") {
      writer.uint32(26).string(message.Text);
    }
    if (message.ToolGroup !== undefined) {
      writer.uint32(32).int32(message.ToolGroup);
    }
    if (message.ToolName !== undefined) {
      writer.uint32(42).string(message.ToolName);
    }
    for (const v of message.AntiPrompts) {
      writer.uint32(50).string(v!);
    }
    if (message.TokensKeep !== undefined) {
      writer.uint32(56).int32(message.TokensKeep);
    }
    if (message.MaxTokens !== undefined) {
      writer.uint32(64).int32(message.MaxTokens);
    }
    if (message.DecodeSpecialTokens !== undefined) {
      writer.uint32(72).bool(message.DecodeSpecialTokens);
    }
    if (message.Temperature !== undefined) {
      writer.uint32(85).float(message.Temperature);
    }
    if (message.TopP !== undefined) {
      writer.uint32(93).float(message.TopP);
    }
    if (message.TopK !== undefined) {
      writer.uint32(96).int32(message.TopK);
    }
    if (message.RepeatPenalty !== undefined) {
      writer.uint32(109).float(message.RepeatPenalty);
    }
    if (message.Seed !== undefined) {
      writer.uint32(112).int32(message.Seed);
    }
    if (message.FrequencyPenalty !== undefined) {
      writer.uint32(125).float(message.FrequencyPenalty);
    }
    if (message.PresencePenalty !== undefined) {
      writer.uint32(133).float(message.PresencePenalty);
    }
    if (message.MinKeep !== undefined) {
      writer.uint32(136).int32(message.MinKeep);
    }
    if (message.MinP !== undefined) {
      writer.uint32(149).float(message.MinP);
    }
    if (message.PenalizeNewline !== undefined) {
      writer.uint32(152).bool(message.PenalizeNewline);
    }
    if (message.PenaltyCount !== undefined) {
      writer.uint32(160).int32(message.PenaltyCount);
    }
    if (message.PreventEOS !== undefined) {
      writer.uint32(168).bool(message.PreventEOS);
    }
    if (message.TypicalP !== undefined) {
      writer.uint32(181).float(message.TypicalP);
    }
    if (message.ThinkLevel !== undefined) {
      writer.uint32(184).int32(message.ThinkLevel);
    }
    if (message.OutputFormat !== undefined) {
      writer.uint32(192).int32(message.OutputFormat);
    }
    if (message.ExampleOutput !== undefined) {
      writer.uint32(202).string(message.ExampleOutput);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SendInferenceRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSendInferenceRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.SessionId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.InferenceId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.Text = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.ToolGroup = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.ToolName = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.AntiPrompts.push(reader.string());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.TokensKeep = reader.int32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.MaxTokens = reader.int32();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.DecodeSpecialTokens = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 85) {
            break;
          }

          message.Temperature = reader.float();
          continue;
        }
        case 11: {
          if (tag !== 93) {
            break;
          }

          message.TopP = reader.float();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.TopK = reader.int32();
          continue;
        }
        case 13: {
          if (tag !== 109) {
            break;
          }

          message.RepeatPenalty = reader.float();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.Seed = reader.int32();
          continue;
        }
        case 15: {
          if (tag !== 125) {
            break;
          }

          message.FrequencyPenalty = reader.float();
          continue;
        }
        case 16: {
          if (tag !== 133) {
            break;
          }

          message.PresencePenalty = reader.float();
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.MinKeep = reader.int32();
          continue;
        }
        case 18: {
          if (tag !== 149) {
            break;
          }

          message.MinP = reader.float();
          continue;
        }
        case 19: {
          if (tag !== 152) {
            break;
          }

          message.PenalizeNewline = reader.bool();
          continue;
        }
        case 20: {
          if (tag !== 160) {
            break;
          }

          message.PenaltyCount = reader.int32();
          continue;
        }
        case 21: {
          if (tag !== 168) {
            break;
          }

          message.PreventEOS = reader.bool();
          continue;
        }
        case 22: {
          if (tag !== 181) {
            break;
          }

          message.TypicalP = reader.float();
          continue;
        }
        case 23: {
          if (tag !== 184) {
            break;
          }

          message.ThinkLevel = reader.int32() as any;
          continue;
        }
        case 24: {
          if (tag !== 192) {
            break;
          }

          message.OutputFormat = reader.int32() as any;
          continue;
        }
        case 25: {
          if (tag !== 202) {
            break;
          }

          message.ExampleOutput = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SendInferenceRequest {
    return {
      SessionId: isSet(object.SessionId) ? globalThis.String(object.SessionId) : "",
      InferenceId: isSet(object.InferenceId) ? globalThis.String(object.InferenceId) : "",
      Text: isSet(object.Text) ? globalThis.String(object.Text) : "",
      ToolGroup: isSet(object.ToolGroup) ? inferenceToolGroupsFromJSON(object.ToolGroup) : undefined,
      ToolName: isSet(object.ToolName) ? globalThis.String(object.ToolName) : undefined,
      AntiPrompts: globalThis.Array.isArray(object?.AntiPrompts)
        ? object.AntiPrompts.map((e: any) => globalThis.String(e))
        : [],
      TokensKeep: isSet(object.TokensKeep) ? globalThis.Number(object.TokensKeep) : undefined,
      MaxTokens: isSet(object.MaxTokens) ? globalThis.Number(object.MaxTokens) : undefined,
      DecodeSpecialTokens: isSet(object.DecodeSpecialTokens)
        ? globalThis.Boolean(object.DecodeSpecialTokens)
        : undefined,
      Temperature: isSet(object.Temperature) ? globalThis.Number(object.Temperature) : undefined,
      TopP: isSet(object.TopP) ? globalThis.Number(object.TopP) : undefined,
      TopK: isSet(object.TopK) ? globalThis.Number(object.TopK) : undefined,
      RepeatPenalty: isSet(object.RepeatPenalty) ? globalThis.Number(object.RepeatPenalty) : undefined,
      Seed: isSet(object.Seed) ? globalThis.Number(object.Seed) : undefined,
      FrequencyPenalty: isSet(object.FrequencyPenalty) ? globalThis.Number(object.FrequencyPenalty) : undefined,
      PresencePenalty: isSet(object.PresencePenalty) ? globalThis.Number(object.PresencePenalty) : undefined,
      MinKeep: isSet(object.MinKeep) ? globalThis.Number(object.MinKeep) : undefined,
      MinP: isSet(object.MinP) ? globalThis.Number(object.MinP) : undefined,
      PenalizeNewline: isSet(object.PenalizeNewline) ? globalThis.Boolean(object.PenalizeNewline) : undefined,
      PenaltyCount: isSet(object.PenaltyCount) ? globalThis.Number(object.PenaltyCount) : undefined,
      PreventEOS: isSet(object.PreventEOS) ? globalThis.Boolean(object.PreventEOS) : undefined,
      TypicalP: isSet(object.TypicalP) ? globalThis.Number(object.TypicalP) : undefined,
      ThinkLevel: isSet(object.ThinkLevel) ? thinkLevelsFromJSON(object.ThinkLevel) : undefined,
      OutputFormat: isSet(object.OutputFormat) ? inferenceOutputFormatsFromJSON(object.OutputFormat) : undefined,
      ExampleOutput: isSet(object.ExampleOutput) ? globalThis.String(object.ExampleOutput) : undefined,
    };
  },

  toJSON(message: SendInferenceRequest): unknown {
    const obj: any = {};
    if (message.SessionId !== "") {
      obj.SessionId = message.SessionId;
    }
    if (message.InferenceId !== "") {
      obj.InferenceId = message.InferenceId;
    }
    if (message.Text !== "") {
      obj.Text = message.Text;
    }
    if (message.ToolGroup !== undefined) {
      obj.ToolGroup = inferenceToolGroupsToJSON(message.ToolGroup);
    }
    if (message.ToolName !== undefined) {
      obj.ToolName = message.ToolName;
    }
    if (message.AntiPrompts?.length) {
      obj.AntiPrompts = message.AntiPrompts;
    }
    if (message.TokensKeep !== undefined) {
      obj.TokensKeep = Math.round(message.TokensKeep);
    }
    if (message.MaxTokens !== undefined) {
      obj.MaxTokens = Math.round(message.MaxTokens);
    }
    if (message.DecodeSpecialTokens !== undefined) {
      obj.DecodeSpecialTokens = message.DecodeSpecialTokens;
    }
    if (message.Temperature !== undefined) {
      obj.Temperature = message.Temperature;
    }
    if (message.TopP !== undefined) {
      obj.TopP = message.TopP;
    }
    if (message.TopK !== undefined) {
      obj.TopK = Math.round(message.TopK);
    }
    if (message.RepeatPenalty !== undefined) {
      obj.RepeatPenalty = message.RepeatPenalty;
    }
    if (message.Seed !== undefined) {
      obj.Seed = Math.round(message.Seed);
    }
    if (message.FrequencyPenalty !== undefined) {
      obj.FrequencyPenalty = message.FrequencyPenalty;
    }
    if (message.PresencePenalty !== undefined) {
      obj.PresencePenalty = message.PresencePenalty;
    }
    if (message.MinKeep !== undefined) {
      obj.MinKeep = Math.round(message.MinKeep);
    }
    if (message.MinP !== undefined) {
      obj.MinP = message.MinP;
    }
    if (message.PenalizeNewline !== undefined) {
      obj.PenalizeNewline = message.PenalizeNewline;
    }
    if (message.PenaltyCount !== undefined) {
      obj.PenaltyCount = Math.round(message.PenaltyCount);
    }
    if (message.PreventEOS !== undefined) {
      obj.PreventEOS = message.PreventEOS;
    }
    if (message.TypicalP !== undefined) {
      obj.TypicalP = message.TypicalP;
    }
    if (message.ThinkLevel !== undefined) {
      obj.ThinkLevel = thinkLevelsToJSON(message.ThinkLevel);
    }
    if (message.OutputFormat !== undefined) {
      obj.OutputFormat = inferenceOutputFormatsToJSON(message.OutputFormat);
    }
    if (message.ExampleOutput !== undefined) {
      obj.ExampleOutput = message.ExampleOutput;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SendInferenceRequest>, I>>(base?: I): SendInferenceRequest {
    return SendInferenceRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SendInferenceRequest>, I>>(object: I): SendInferenceRequest {
    const message = createBaseSendInferenceRequest();
    message.SessionId = object.SessionId ?? "";
    message.InferenceId = object.InferenceId ?? "";
    message.Text = object.Text ?? "";
    message.ToolGroup = object.ToolGroup ?? undefined;
    message.ToolName = object.ToolName ?? undefined;
    message.AntiPrompts = object.AntiPrompts?.map((e) => e) || [];
    message.TokensKeep = object.TokensKeep ?? undefined;
    message.MaxTokens = object.MaxTokens ?? undefined;
    message.DecodeSpecialTokens = object.DecodeSpecialTokens ?? undefined;
    message.Temperature = object.Temperature ?? undefined;
    message.TopP = object.TopP ?? undefined;
    message.TopK = object.TopK ?? undefined;
    message.RepeatPenalty = object.RepeatPenalty ?? undefined;
    message.Seed = object.Seed ?? undefined;
    message.FrequencyPenalty = object.FrequencyPenalty ?? undefined;
    message.PresencePenalty = object.PresencePenalty ?? undefined;
    message.MinKeep = object.MinKeep ?? undefined;
    message.MinP = object.MinP ?? undefined;
    message.PenalizeNewline = object.PenalizeNewline ?? undefined;
    message.PenaltyCount = object.PenaltyCount ?? undefined;
    message.PreventEOS = object.PreventEOS ?? undefined;
    message.TypicalP = object.TypicalP ?? undefined;
    message.ThinkLevel = object.ThinkLevel ?? undefined;
    message.OutputFormat = object.OutputFormat ?? undefined;
    message.ExampleOutput = object.ExampleOutput ?? undefined;
    return message;
  },
};

function createBaseSendInferenceResponse(): SendInferenceResponse {
  return {
    SessionId: "",
    InferenceId: "",
    Id: "",
    Type: 0,
    Content: "",
    AuthorRole: "",
    Format: 0,
    MessageTokenCount: 0,
    SessionTokenCount: 0,
    ComputeTimeMs: 0,
  };
}

export const SendInferenceResponse: MessageFns<SendInferenceResponse> = {
  encode(message: SendInferenceResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.SessionId !== "") {
      writer.uint32(10).string(message.SessionId);
    }
    if (message.InferenceId !== "") {
      writer.uint32(18).string(message.InferenceId);
    }
    if (message.Id !== "") {
      writer.uint32(26).string(message.Id);
    }
    if (message.Type !== 0) {
      writer.uint32(32).int32(message.Type);
    }
    if (message.Content !== "") {
      writer.uint32(42).string(message.Content);
    }
    if (message.AuthorRole !== "") {
      writer.uint32(50).string(message.AuthorRole);
    }
    if (message.Format !== 0) {
      writer.uint32(56).int32(message.Format);
    }
    if (message.MessageTokenCount !== 0) {
      writer.uint32(64).int32(message.MessageTokenCount);
    }
    if (message.SessionTokenCount !== 0) {
      writer.uint32(72).int32(message.SessionTokenCount);
    }
    if (message.ComputeTimeMs !== 0) {
      writer.uint32(80).int32(message.ComputeTimeMs);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SendInferenceResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSendInferenceResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.SessionId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.InferenceId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.Id = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.Type = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.Content = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.AuthorRole = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.Format = reader.int32() as any;
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.MessageTokenCount = reader.int32();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.SessionTokenCount = reader.int32();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.ComputeTimeMs = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SendInferenceResponse {
    return {
      SessionId: isSet(object.SessionId) ? globalThis.String(object.SessionId) : "",
      InferenceId: isSet(object.InferenceId) ? globalThis.String(object.InferenceId) : "",
      Id: isSet(object.Id) ? globalThis.String(object.Id) : "",
      Type: isSet(object.Type) ? inferenceResponseTypesFromJSON(object.Type) : 0,
      Content: isSet(object.Content) ? globalThis.String(object.Content) : "",
      AuthorRole: isSet(object.AuthorRole) ? globalThis.String(object.AuthorRole) : "",
      Format: isSet(object.Format) ? inferenceOutputFormatsFromJSON(object.Format) : 0,
      MessageTokenCount: isSet(object.MessageTokenCount) ? globalThis.Number(object.MessageTokenCount) : 0,
      SessionTokenCount: isSet(object.SessionTokenCount) ? globalThis.Number(object.SessionTokenCount) : 0,
      ComputeTimeMs: isSet(object.ComputeTimeMs) ? globalThis.Number(object.ComputeTimeMs) : 0,
    };
  },

  toJSON(message: SendInferenceResponse): unknown {
    const obj: any = {};
    if (message.SessionId !== "") {
      obj.SessionId = message.SessionId;
    }
    if (message.InferenceId !== "") {
      obj.InferenceId = message.InferenceId;
    }
    if (message.Id !== "") {
      obj.Id = message.Id;
    }
    if (message.Type !== 0) {
      obj.Type = inferenceResponseTypesToJSON(message.Type);
    }
    if (message.Content !== "") {
      obj.Content = message.Content;
    }
    if (message.AuthorRole !== "") {
      obj.AuthorRole = message.AuthorRole;
    }
    if (message.Format !== 0) {
      obj.Format = inferenceOutputFormatsToJSON(message.Format);
    }
    if (message.MessageTokenCount !== 0) {
      obj.MessageTokenCount = Math.round(message.MessageTokenCount);
    }
    if (message.SessionTokenCount !== 0) {
      obj.SessionTokenCount = Math.round(message.SessionTokenCount);
    }
    if (message.ComputeTimeMs !== 0) {
      obj.ComputeTimeMs = Math.round(message.ComputeTimeMs);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SendInferenceResponse>, I>>(base?: I): SendInferenceResponse {
    return SendInferenceResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SendInferenceResponse>, I>>(object: I): SendInferenceResponse {
    const message = createBaseSendInferenceResponse();
    message.SessionId = object.SessionId ?? "";
    message.InferenceId = object.InferenceId ?? "";
    message.Id = object.Id ?? "";
    message.Type = object.Type ?? 0;
    message.Content = object.Content ?? "";
    message.AuthorRole = object.AuthorRole ?? "";
    message.Format = object.Format ?? 0;
    message.MessageTokenCount = object.MessageTokenCount ?? 0;
    message.SessionTokenCount = object.SessionTokenCount ?? 0;
    message.ComputeTimeMs = object.ComputeTimeMs ?? 0;
    return message;
  },
};

function createBaseInferenceStatsRequest(): InferenceStatsRequest {
  return { SessionId: "", InferenceId: "" };
}

export const InferenceStatsRequest: MessageFns<InferenceStatsRequest> = {
  encode(message: InferenceStatsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.SessionId !== "") {
      writer.uint32(10).string(message.SessionId);
    }
    if (message.InferenceId !== "") {
      writer.uint32(18).string(message.InferenceId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InferenceStatsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInferenceStatsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.SessionId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.InferenceId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InferenceStatsRequest {
    return {
      SessionId: isSet(object.SessionId) ? globalThis.String(object.SessionId) : "",
      InferenceId: isSet(object.InferenceId) ? globalThis.String(object.InferenceId) : "",
    };
  },

  toJSON(message: InferenceStatsRequest): unknown {
    const obj: any = {};
    if (message.SessionId !== "") {
      obj.SessionId = message.SessionId;
    }
    if (message.InferenceId !== "") {
      obj.InferenceId = message.InferenceId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<InferenceStatsRequest>, I>>(base?: I): InferenceStatsRequest {
    return InferenceStatsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InferenceStatsRequest>, I>>(object: I): InferenceStatsRequest {
    const message = createBaseInferenceStatsRequest();
    message.SessionId = object.SessionId ?? "";
    message.InferenceId = object.InferenceId ?? "";
    return message;
  },
};

function createBaseInferenceStatsResponse(): InferenceStatsResponse {
  return {
    SessionId: "",
    InferenceId: "",
    Success: false,
    LastMessageTokenCount: 0,
    SessionTokenCount: 0,
    LastMessageToolCount: 0,
    SessionToolCount: 0,
    LastMessageComputeTimeMs: 0,
    SessionComputeTimeMs: 0,
  };
}

export const InferenceStatsResponse: MessageFns<InferenceStatsResponse> = {
  encode(message: InferenceStatsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.SessionId !== "") {
      writer.uint32(10).string(message.SessionId);
    }
    if (message.InferenceId !== "") {
      writer.uint32(18).string(message.InferenceId);
    }
    if (message.Success !== false) {
      writer.uint32(24).bool(message.Success);
    }
    if (message.LastMessageTokenCount !== 0) {
      writer.uint32(32).int32(message.LastMessageTokenCount);
    }
    if (message.SessionTokenCount !== 0) {
      writer.uint32(40).int32(message.SessionTokenCount);
    }
    if (message.LastMessageToolCount !== 0) {
      writer.uint32(48).int32(message.LastMessageToolCount);
    }
    if (message.SessionToolCount !== 0) {
      writer.uint32(56).int32(message.SessionToolCount);
    }
    if (message.LastMessageComputeTimeMs !== 0) {
      writer.uint32(64).int32(message.LastMessageComputeTimeMs);
    }
    if (message.SessionComputeTimeMs !== 0) {
      writer.uint32(72).int32(message.SessionComputeTimeMs);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InferenceStatsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInferenceStatsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.SessionId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.InferenceId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.Success = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.LastMessageTokenCount = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.SessionTokenCount = reader.int32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.LastMessageToolCount = reader.int32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.SessionToolCount = reader.int32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.LastMessageComputeTimeMs = reader.int32();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.SessionComputeTimeMs = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InferenceStatsResponse {
    return {
      SessionId: isSet(object.SessionId) ? globalThis.String(object.SessionId) : "",
      InferenceId: isSet(object.InferenceId) ? globalThis.String(object.InferenceId) : "",
      Success: isSet(object.Success) ? globalThis.Boolean(object.Success) : false,
      LastMessageTokenCount: isSet(object.LastMessageTokenCount) ? globalThis.Number(object.LastMessageTokenCount) : 0,
      SessionTokenCount: isSet(object.SessionTokenCount) ? globalThis.Number(object.SessionTokenCount) : 0,
      LastMessageToolCount: isSet(object.LastMessageToolCount) ? globalThis.Number(object.LastMessageToolCount) : 0,
      SessionToolCount: isSet(object.SessionToolCount) ? globalThis.Number(object.SessionToolCount) : 0,
      LastMessageComputeTimeMs: isSet(object.LastMessageComputeTimeMs)
        ? globalThis.Number(object.LastMessageComputeTimeMs)
        : 0,
      SessionComputeTimeMs: isSet(object.SessionComputeTimeMs) ? globalThis.Number(object.SessionComputeTimeMs) : 0,
    };
  },

  toJSON(message: InferenceStatsResponse): unknown {
    const obj: any = {};
    if (message.SessionId !== "") {
      obj.SessionId = message.SessionId;
    }
    if (message.InferenceId !== "") {
      obj.InferenceId = message.InferenceId;
    }
    if (message.Success !== false) {
      obj.Success = message.Success;
    }
    if (message.LastMessageTokenCount !== 0) {
      obj.LastMessageTokenCount = Math.round(message.LastMessageTokenCount);
    }
    if (message.SessionTokenCount !== 0) {
      obj.SessionTokenCount = Math.round(message.SessionTokenCount);
    }
    if (message.LastMessageToolCount !== 0) {
      obj.LastMessageToolCount = Math.round(message.LastMessageToolCount);
    }
    if (message.SessionToolCount !== 0) {
      obj.SessionToolCount = Math.round(message.SessionToolCount);
    }
    if (message.LastMessageComputeTimeMs !== 0) {
      obj.LastMessageComputeTimeMs = Math.round(message.LastMessageComputeTimeMs);
    }
    if (message.SessionComputeTimeMs !== 0) {
      obj.SessionComputeTimeMs = Math.round(message.SessionComputeTimeMs);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<InferenceStatsResponse>, I>>(base?: I): InferenceStatsResponse {
    return InferenceStatsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InferenceStatsResponse>, I>>(object: I): InferenceStatsResponse {
    const message = createBaseInferenceStatsResponse();
    message.SessionId = object.SessionId ?? "";
    message.InferenceId = object.InferenceId ?? "";
    message.Success = object.Success ?? false;
    message.LastMessageTokenCount = object.LastMessageTokenCount ?? 0;
    message.SessionTokenCount = object.SessionTokenCount ?? 0;
    message.LastMessageToolCount = object.LastMessageToolCount ?? 0;
    message.SessionToolCount = object.SessionToolCount ?? 0;
    message.LastMessageComputeTimeMs = object.LastMessageComputeTimeMs ?? 0;
    message.SessionComputeTimeMs = object.SessionComputeTimeMs ?? 0;
    return message;
  },
};

function createBaseCreateInferenceRequest(): CreateInferenceRequest {
  return { SessionId: "", ModelName: "", InitializationPrompt: "", ThinkLevel: 0, ToolGroups: [] };
}

export const CreateInferenceRequest: MessageFns<CreateInferenceRequest> = {
  encode(message: CreateInferenceRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.SessionId !== "") {
      writer.uint32(10).string(message.SessionId);
    }
    if (message.ModelName !== "") {
      writer.uint32(18).string(message.ModelName);
    }
    if (message.InitializationPrompt !== "") {
      writer.uint32(26).string(message.InitializationPrompt);
    }
    if (message.ThinkLevel !== 0) {
      writer.uint32(32).int32(message.ThinkLevel);
    }
    writer.uint32(42).fork();
    for (const v of message.ToolGroups) {
      writer.int32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateInferenceRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateInferenceRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.SessionId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ModelName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.InitializationPrompt = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.ThinkLevel = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag === 40) {
            message.ToolGroups.push(reader.int32() as any);

            continue;
          }

          if (tag === 42) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.ToolGroups.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateInferenceRequest {
    return {
      SessionId: isSet(object.SessionId) ? globalThis.String(object.SessionId) : "",
      ModelName: isSet(object.ModelName) ? globalThis.String(object.ModelName) : "",
      InitializationPrompt: isSet(object.InitializationPrompt) ? globalThis.String(object.InitializationPrompt) : "",
      ThinkLevel: isSet(object.ThinkLevel) ? thinkLevelsFromJSON(object.ThinkLevel) : 0,
      ToolGroups: globalThis.Array.isArray(object?.ToolGroups)
        ? object.ToolGroups.map((e: any) => inferenceToolGroupsFromJSON(e))
        : [],
    };
  },

  toJSON(message: CreateInferenceRequest): unknown {
    const obj: any = {};
    if (message.SessionId !== "") {
      obj.SessionId = message.SessionId;
    }
    if (message.ModelName !== "") {
      obj.ModelName = message.ModelName;
    }
    if (message.InitializationPrompt !== "") {
      obj.InitializationPrompt = message.InitializationPrompt;
    }
    if (message.ThinkLevel !== 0) {
      obj.ThinkLevel = thinkLevelsToJSON(message.ThinkLevel);
    }
    if (message.ToolGroups?.length) {
      obj.ToolGroups = message.ToolGroups.map((e) => inferenceToolGroupsToJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateInferenceRequest>, I>>(base?: I): CreateInferenceRequest {
    return CreateInferenceRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateInferenceRequest>, I>>(object: I): CreateInferenceRequest {
    const message = createBaseCreateInferenceRequest();
    message.SessionId = object.SessionId ?? "";
    message.ModelName = object.ModelName ?? "";
    message.InitializationPrompt = object.InitializationPrompt ?? "";
    message.ThinkLevel = object.ThinkLevel ?? 0;
    message.ToolGroups = object.ToolGroups?.map((e) => e) || [];
    return message;
  },
};

function createBaseCreateInferenceResponse(): CreateInferenceResponse {
  return { SessionId: "", InferenceId: "" };
}

export const CreateInferenceResponse: MessageFns<CreateInferenceResponse> = {
  encode(message: CreateInferenceResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.SessionId !== "") {
      writer.uint32(10).string(message.SessionId);
    }
    if (message.InferenceId !== "") {
      writer.uint32(18).string(message.InferenceId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateInferenceResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateInferenceResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.SessionId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.InferenceId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateInferenceResponse {
    return {
      SessionId: isSet(object.SessionId) ? globalThis.String(object.SessionId) : "",
      InferenceId: isSet(object.InferenceId) ? globalThis.String(object.InferenceId) : "",
    };
  },

  toJSON(message: CreateInferenceResponse): unknown {
    const obj: any = {};
    if (message.SessionId !== "") {
      obj.SessionId = message.SessionId;
    }
    if (message.InferenceId !== "") {
      obj.InferenceId = message.InferenceId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateInferenceResponse>, I>>(base?: I): CreateInferenceResponse {
    return CreateInferenceResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateInferenceResponse>, I>>(object: I): CreateInferenceResponse {
    const message = createBaseCreateInferenceResponse();
    message.SessionId = object.SessionId ?? "";
    message.InferenceId = object.InferenceId ?? "";
    return message;
  },
};

function createBaseCloseInferenceRequest(): CloseInferenceRequest {
  return { SessionId: "", InferenceId: "", Reason: 0 };
}

export const CloseInferenceRequest: MessageFns<CloseInferenceRequest> = {
  encode(message: CloseInferenceRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.SessionId !== "") {
      writer.uint32(10).string(message.SessionId);
    }
    if (message.InferenceId !== "") {
      writer.uint32(18).string(message.InferenceId);
    }
    if (message.Reason !== 0) {
      writer.uint32(24).int32(message.Reason);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CloseInferenceRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCloseInferenceRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.SessionId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.InferenceId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.Reason = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CloseInferenceRequest {
    return {
      SessionId: isSet(object.SessionId) ? globalThis.String(object.SessionId) : "",
      InferenceId: isSet(object.InferenceId) ? globalThis.String(object.InferenceId) : "",
      Reason: isSet(object.Reason) ? inferenceCloseReasonsFromJSON(object.Reason) : 0,
    };
  },

  toJSON(message: CloseInferenceRequest): unknown {
    const obj: any = {};
    if (message.SessionId !== "") {
      obj.SessionId = message.SessionId;
    }
    if (message.InferenceId !== "") {
      obj.InferenceId = message.InferenceId;
    }
    if (message.Reason !== 0) {
      obj.Reason = inferenceCloseReasonsToJSON(message.Reason);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CloseInferenceRequest>, I>>(base?: I): CloseInferenceRequest {
    return CloseInferenceRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CloseInferenceRequest>, I>>(object: I): CloseInferenceRequest {
    const message = createBaseCloseInferenceRequest();
    message.SessionId = object.SessionId ?? "";
    message.InferenceId = object.InferenceId ?? "";
    message.Reason = object.Reason ?? 0;
    return message;
  },
};

function createBaseCloseInferenceResponse(): CloseInferenceResponse {
  return { SessionId: "", InferenceId: "", Success: false };
}

export const CloseInferenceResponse: MessageFns<CloseInferenceResponse> = {
  encode(message: CloseInferenceResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.SessionId !== "") {
      writer.uint32(10).string(message.SessionId);
    }
    if (message.InferenceId !== "") {
      writer.uint32(18).string(message.InferenceId);
    }
    if (message.Success !== false) {
      writer.uint32(24).bool(message.Success);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CloseInferenceResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCloseInferenceResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.SessionId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.InferenceId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.Success = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CloseInferenceResponse {
    return {
      SessionId: isSet(object.SessionId) ? globalThis.String(object.SessionId) : "",
      InferenceId: isSet(object.InferenceId) ? globalThis.String(object.InferenceId) : "",
      Success: isSet(object.Success) ? globalThis.Boolean(object.Success) : false,
    };
  },

  toJSON(message: CloseInferenceResponse): unknown {
    const obj: any = {};
    if (message.SessionId !== "") {
      obj.SessionId = message.SessionId;
    }
    if (message.InferenceId !== "") {
      obj.InferenceId = message.InferenceId;
    }
    if (message.Success !== false) {
      obj.Success = message.Success;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CloseInferenceResponse>, I>>(base?: I): CloseInferenceResponse {
    return CloseInferenceResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CloseInferenceResponse>, I>>(object: I): CloseInferenceResponse {
    const message = createBaseCloseInferenceResponse();
    message.SessionId = object.SessionId ?? "";
    message.InferenceId = object.InferenceId ?? "";
    message.Success = object.Success ?? false;
    return message;
  },
};

function createBaseInferenceReceipt(): InferenceReceipt {
  return {
    InferenceId: "",
    SessionId: "",
    HostId: "",
    ConsumerAccountId: "",
    TokenCount: 0,
    ComputeTimeMs: 0,
    ModelName: "",
    Timestamp: undefined,
    ConsumerClientKey: "",
  };
}

export const InferenceReceipt: MessageFns<InferenceReceipt> = {
  encode(message: InferenceReceipt, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.InferenceId !== "") {
      writer.uint32(10).string(message.InferenceId);
    }
    if (message.SessionId !== "") {
      writer.uint32(18).string(message.SessionId);
    }
    if (message.HostId !== "") {
      writer.uint32(26).string(message.HostId);
    }
    if (message.ConsumerAccountId !== "") {
      writer.uint32(34).string(message.ConsumerAccountId);
    }
    if (message.TokenCount !== 0) {
      writer.uint32(40).int32(message.TokenCount);
    }
    if (message.ComputeTimeMs !== 0) {
      writer.uint32(48).int32(message.ComputeTimeMs);
    }
    if (message.ModelName !== "") {
      writer.uint32(58).string(message.ModelName);
    }
    if (message.Timestamp !== undefined) {
      Timestamp.encode(toTimestamp(message.Timestamp), writer.uint32(66).fork()).join();
    }
    if (message.ConsumerClientKey !== "") {
      writer.uint32(74).string(message.ConsumerClientKey);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InferenceReceipt {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInferenceReceipt();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.InferenceId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.SessionId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.HostId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.ConsumerAccountId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.TokenCount = reader.int32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.ComputeTimeMs = reader.int32();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.ModelName = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.Timestamp = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.ConsumerClientKey = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InferenceReceipt {
    return {
      InferenceId: isSet(object.InferenceId) ? globalThis.String(object.InferenceId) : "",
      SessionId: isSet(object.SessionId) ? globalThis.String(object.SessionId) : "",
      HostId: isSet(object.HostId) ? globalThis.String(object.HostId) : "",
      ConsumerAccountId: isSet(object.ConsumerAccountId) ? globalThis.String(object.ConsumerAccountId) : "",
      TokenCount: isSet(object.TokenCount) ? globalThis.Number(object.TokenCount) : 0,
      ComputeTimeMs: isSet(object.ComputeTimeMs) ? globalThis.Number(object.ComputeTimeMs) : 0,
      ModelName: isSet(object.ModelName) ? globalThis.String(object.ModelName) : "",
      Timestamp: isSet(object.Timestamp) ? fromJsonTimestamp(object.Timestamp) : undefined,
      ConsumerClientKey: isSet(object.ConsumerClientKey) ? globalThis.String(object.ConsumerClientKey) : "",
    };
  },

  toJSON(message: InferenceReceipt): unknown {
    const obj: any = {};
    if (message.InferenceId !== "") {
      obj.InferenceId = message.InferenceId;
    }
    if (message.SessionId !== "") {
      obj.SessionId = message.SessionId;
    }
    if (message.HostId !== "") {
      obj.HostId = message.HostId;
    }
    if (message.ConsumerAccountId !== "") {
      obj.ConsumerAccountId = message.ConsumerAccountId;
    }
    if (message.TokenCount !== 0) {
      obj.TokenCount = Math.round(message.TokenCount);
    }
    if (message.ComputeTimeMs !== 0) {
      obj.ComputeTimeMs = Math.round(message.ComputeTimeMs);
    }
    if (message.ModelName !== "") {
      obj.ModelName = message.ModelName;
    }
    if (message.Timestamp !== undefined) {
      obj.Timestamp = message.Timestamp.toISOString();
    }
    if (message.ConsumerClientKey !== "") {
      obj.ConsumerClientKey = message.ConsumerClientKey;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<InferenceReceipt>, I>>(base?: I): InferenceReceipt {
    return InferenceReceipt.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InferenceReceipt>, I>>(object: I): InferenceReceipt {
    const message = createBaseInferenceReceipt();
    message.InferenceId = object.InferenceId ?? "";
    message.SessionId = object.SessionId ?? "";
    message.HostId = object.HostId ?? "";
    message.ConsumerAccountId = object.ConsumerAccountId ?? "";
    message.TokenCount = object.TokenCount ?? 0;
    message.ComputeTimeMs = object.ComputeTimeMs ?? 0;
    message.ModelName = object.ModelName ?? "";
    message.Timestamp = object.Timestamp ?? undefined;
    message.ConsumerClientKey = object.ConsumerClientKey ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(date: Date): Timestamp {
  const seconds = numberToLong(Math.trunc(date.getTime() / 1_000));
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds.toNumber() || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function numberToLong(number: number) {
  return Long.fromNumber(number);
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
